import styled from 'styled-components';

export const Root = styled.section`
    ${({ reviewsFetched }) => !reviewsFetched && `
        display: none;
    `}
    overflow-x: hidden;
    padding-top: 80px;
    padding-bottom: 70px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors['Level 1']};
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`  
        margin-right: calc(-1 * ${({ theme }) => theme.spacers.L});
        padding-bottom: 24px;
        padding-left: 16px;
    `};
`;
